import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { UiComponents, initialize, UnoStoreHooks } from "@simulanisindia/ui";

import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import RemoveOutlinedIcon from "@mui/icons-material/RemoveOutlined";
import { FilterIcon, MinusIcon, PLusIcon, RemoveIcon, SearchIcon, SideArrow } from "../../assets/Icons.js";
import { findAllCategoryIds, findCategoryOption, searchCategory } from "../../utils/general.js";

const { useUnoSelector } = UnoStoreHooks;


const FilterTab = ({
    selectedCheckboxes = [],
    setSelectedCheckboxes,
    filterOptions,
    onToggleFilter,
    showfilter,
    categoryOptions = null,
    handleResetCheckBox
}) => {
    const configData = useUnoSelector((state) => state.config);

    const [sortingOpen, setSortingOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [currentTab, setCurrentTab] = useState(null);
    const [categoryList, setCategoryList] = useState(null);
    const [selectedCategoryCheckboxes, setSelectedCategoryCheckboxes] = useState([]);
    const [selectedTagCheckboxes, setSelectedTagCheckboxes] = useState([]);

    useEffect(() => {
        setCategoryList(categoryOptions || null);
    }, [categoryOptions]);

    useEffect(()=>{
        setSelectedCategoryCheckboxes(selectedCheckboxes.filter(e => e.type === "tagCategory"));
        setSelectedTagCheckboxes(selectedCheckboxes.filter(e => e.type !== "tagCategory"));
    },[selectedCheckboxes]);

    const handleCheckboxChange = (item) => {
        if (setSelectedCheckboxes) setSelectedCheckboxes(item, false);
    };

    const isChecked = (item) => {
        return selectedTagCheckboxes.find((value) => value.value === item.value) ? true : false;
    };

    const openSorting = () => {
        setSortingOpen(!sortingOpen);
    };

    const handleReset = () => {
        if (handleResetCheckBox) handleResetCheckBox();
        setSearchQuery("");
    };

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const handleBackCategory = (id) => {
        const result = searchCategory(id, categoryOptions);
        setCategoryList(result || null);
    };

    const getSelectedCount = (filterName) => {
        const selectedCount = selectedTagCheckboxes.filter((item) => {
            const filter = filterOptions.find((filter) => filter.name === filterName);
            return filter.tags.some((tag) => tag.key === item.key);
        }).length;

        return selectedCount > 9 ? "9+" : selectedCount.toString();
    };

    const toggleExpand = (item) => {
        let find = categoryList.children.find((e) => e.id == item.id);
        if(find.children.length === 0) return;
        setCategoryList(find || null);
    };

    const handleSelectCategory = (e, category, isChecked) => {
        e.stopPropagation();
        let findCategory = findCategoryOption(categoryOptions, category.id);
        let allChildrenCategoryIds = findAllCategoryIds(findCategory);

        const updateIds = (oldIds, newIds, addNewIds) => {
            const existingIds = new Set(oldIds.map(item => item.id));

            if (addNewIds) {
                const uniqueNewIds = newIds.filter(item => !existingIds.has(item.id));
                return [...oldIds, ...uniqueNewIds];
            } else {
                const filteredOldIds = oldIds.filter(item => !newIds.some(newItem => newItem.id === item.id));
                return filteredOldIds;
            }
        };

        let allIdsList = updateIds(selectedCategoryCheckboxes, allChildrenCategoryIds, !isChecked);
        let updatedAllIds = allIdsList.map(e => ({
            "name": e.name,
            "key": e.id,
            "value": e.id,
            "id": e.id,
            "type": "tagCategory"
        }));

        if (setSelectedCheckboxes) setSelectedCheckboxes(updatedAllIds, true);

    };



    const renderCount = (filterName) => {
        const count = getSelectedCount(filterName);

        return count !== "0" ? <span className="numbercount count">{count}</span> : null;
    };

    const switchFilterOptions = filterOptions.filter((item) => item?.type === "radio");
    const _filterOptions = filterOptions.filter((item) => item?.type !== "radio");

    return (
        <>
            <div className={showfilter ? "filterbox" : "filterbox inactive"}>
                <div className="filterhead">
                    <p>
                        <FilterIcon /> Filter
                    </p>
                    <button onClick={handleReset}>Reset</button>
                </div>

                {categoryOptions &&
                    <div className={`createdfilter ${currentTab == "categoryOpen" ? "createdactive" : ""}`}>
                        <div className="createrhead" onClick={() => setCurrentTab((pre) => (pre == "categoryOpen" ? null : "categoryOpen"))}>
                            <span className="d-flex align-items-center justify-content-start gap-2">
                                <p className="d-flex align-items-center justify-content-start">
                                    <span
                                        className="prev rotateIcon"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleBackCategory(categoryList.parentId);
                                        }}
                                    >
                                        {categoryList && (categoryList?.id != configData?.config?.categoryFilterId) && <SideArrow />}
                                    </span>

                                    <span className="d-flex align-items-center justify-content-start gap-2">
                                        {categoryList?.name || "Categories"}
                                        {selectedCategoryCheckboxes.length > 0 && (
                                            <sup>
                                                <span className="numbercount count"> {selectedCategoryCheckboxes.length}</span>
                                            </sup>
                                        )}
                                    </span>
                                </p>
                            </span>
                            <p>
                                {currentTab == "categoryOpen" ? <RemoveOutlinedIcon /> : <AddOutlinedIcon />}{" "}
                            </p>
                        </div>

                        {currentTab == "categoryOpen" && (
                            <>
                                <div className="searchfields form-group position-relative mt-2 mb-1">
                                    <span className="searchicon">
                                        <SearchIcon />
                                    </span>
                                    <input
                                        type="text"
                                        placeholder="Search.."
                                        className="form-control"
                                        value={searchQuery}
                                        onChange={handleSearchChange}
                                    />
                                    {/* {searchQuery.length > 0 && (
                                        <span className="filterSearchCancel searchiconcancel" onClick={() => setSearchQuery("")}>
                                            <RemoveIcon />
                                        </span>
                                    )} */}
                                </div>
                                <div className="createdatahere">
                                    {categoryList &&
                                        categoryList?.children?.filter((e) => e.name.toLowerCase().includes(searchQuery.toLowerCase())).map((item, index) => {
                                            if (searchQuery.length && !item.name.toLowerCase().includes(searchQuery)) return null;
                                            const isChecked = selectedCategoryCheckboxes.some((checkbox) => checkbox.id === item.id);
                                            return (
                                                <div className="data-item d-flex align-items-center justify-content-between" onClick={() => toggleExpand(item)}>
                                                    <div className="check-name d-flex align-items-center py-1">
                                                        <label
                                                            htmlFor={`flexSwitchCheckDefault_${index}`}
                                                            className="w-100 d-flex"
                                                            style={{ cursor: "pointer", margin: 0, }}
                                                        >
                                                            <div className="form-check simcheck">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    // role="switch"
                                                                    // id={`flexSwitchCheckDefault_${index}`}
                                                                    checked={isChecked}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                    onChange={(e) => handleSelectCategory(e, { id: item.id, name: item.name, type: "category" }, isChecked)}
                                                                />
                                                            </div>
                                                            <span style={{ margin: 0, overflow: 'inherit' }}>{item.name}</span>

                                                        </label>
                                                        <p
                                                            onClick={() => {
                                                                item.children?.length > 0 && toggleExpand(item);
                                                            }}
                                                        >
                                                            {/* {item.name} */}
                                                        </p>
                                                    </div>

                                                    {item.children?.length > 0 && (
                                                        <span className="next filternextforward">
                                                            <SideArrow />
                                                        </span>
                                                    )}
                                                </div>
                                            );
                                        })}
                                </div>
                            </>
                        )}


                    </div>
                }

                {switchFilterOptions.map((item, index) => {
                    return (
                        <>
                            <div className="createdfilter">
                                <div className={`togglebtn createrhead ${index === 0 ? "" : ""}`}>
                                    <label
                                        htmlFor={`flexSwitchCheckDefault_${index}`}
                                        className="w-100"
                                        style={{ cursor: "pointer", margin: 0 }}
                                    >
                                        <p style={{ margin: 0 }}>{item.name}</p>
                                        <div className="form-check form-switch simfilterswitch">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                role="switch"
                                                id={`flexSwitchCheckDefault_${index}`}
                                                checked={isChecked(item)}
                                                onChange={() => handleCheckboxChange(item)}
                                            />
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </>
                    );
                })}

                {_filterOptions.map((filter, index) => (
                    <div key={index} className={`createdfilter ${currentTab === index ? "createdactive" : ""}`}>
                        <div className="createrhead" onClick={() => setCurrentTab(currentTab === index ? null : index)}>
                            <span className="d-flex align-items-center justify-content-start gap-2 position-relative">
                                <p>
                                    {filter.name}
                                    <sup>{renderCount(filter.name)}</sup>{" "}
                                </p>
                            </span>
                            <p>{currentTab === index ? <MinusIcon /> : <PLusIcon />}</p>
                        </div>

                        {currentTab === index ? (
                            <>
                                <div className="searchfields form-group position-relative mt-2 mb-1">
                                    <span className="searchicon">
                                        <SearchIcon />
                                    </span>
                                    <input
                                        type="text"
                                        placeholder="Search.."
                                        className="form-control"
                                        value={searchQuery}
                                        onChange={handleSearchChange}
                                    />
                                    {searchQuery.length > 0 && (
                                        <span className="filterSearchCancel searchiconcancel" onClick={() => setSearchQuery("")}>
                                            <RemoveIcon />
                                        </span>
                                    )}
                                </div>
                                <div className="createdatahere mt-0 pe-2">
                                    <div className="checkbox-list">
                                        {filter.tags
                                            .filter((item) => item.name.toLowerCase().includes(searchQuery.toLowerCase()))
                                            .map((item, subIndex) => (
                                                <div key={subIndex} className="checkbox-item">
                                                    <label class="form-check simcheck">
                                                        <input
                                                            class="form-check-input"
                                                            type="checkbox"
                                                            checked={isChecked(item)}
                                                            onChange={() => handleCheckboxChange(item)}
                                                        />
                                                        <span>{item.name}</span>
                                                    </label>
                                                </div>
                                            ))}
                                    </div>
                                </div>
                            </>
                        ) : null}
                    </div>
                ))}
            </div>

            {showfilter && <div className="showoverlay" onClick={onToggleFilter}></div>}
            {sortingOpen && <div className="showoverlay" onClick={openSorting}></div>}
        </>
    );
};

export default FilterTab;
